import {
  Columns,
  LoadingModule,
} from '@domain-group/suit-theme'

import useInvoice from '@hooks/useInvoice'

import BillingDetails from '../BillingDetails'
import DebtorDetails from '../DebtorDetails'
import EditInvoiceTools from '../EditInvoiceTools'
import InvoiceAttachments from '../InvoiceAttachments'
import InvoiceItemsTable from '../InvoiceItemsTable'
import LinkedEntities from '../LinkedEntities'
import PageLayout from '../../../../components/PageLayout'

interface PageContentProps {
  invoiceId: number,
}
const PageContent = (props: PageContentProps) => {
  const { invoiceId } = props

  const invoicePayload = useInvoice({ id: invoiceId })
  const {
    invoice,
    loading,
  } = invoicePayload

  return (
    <PageLayout invoicePayload={invoicePayload} activeTabBarItemKey="details">
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <DebtorDetails invoicePayload={invoicePayload} />

            <InvoiceItemsTable invoice={invoice} />
          </>
        )}

      </Columns.Main>

      <Columns.Sidebar>
        <EditInvoiceTools invoicePayload={invoicePayload} />

        <BillingDetails invoicePayload={invoicePayload} />

        <InvoiceAttachments invoice={invoice} />

        <LinkedEntities invoicePayload={invoicePayload} />
      </Columns.Sidebar>
    </PageLayout>
  )
}
export default PageContent
